exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sweep-code-dialog[data-v-d0d6d888]{padding:0 20px 10px}.sweep-code-dialog .title[data-v-d0d6d888]{font-size:18px;color:#333;text-align:center;margin-bottom:18px;font-weight:700}.sweep-code-dialog .tips[data-v-d0d6d888]{font-size:14px;color:#999;text-align:center;margin-top:20px}", ""]);

// exports
